import { ChangeDetectionStrategy, Component, Signal, ViewEncapsulation, computed } from '@angular/core';
import { FormFieldComponent } from '../form-field.component.js';
import { ISODate } from 'lib/time/index.js';
import { FlatPickrOutputOptions } from 'node_modules/angularx-flatpickr/lib/flatpickr.directive.js';

@Component({
    selector: 'ui-date-form-field',
    templateUrl: './date-form-field.component.html',
    styleUrls: ['../form-fields.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DateFormFieldComponent extends FormFieldComponent<ISODate> {
	/**
	 * https://flatpickr.js.org/formatting/
	 */
	public readonly altFormat: string = 'd M Y';
	public selectedDate: Signal<Date | undefined> = computed(() => {
		const rawValue = this.rawValue();

		if (!rawValue) {
			return undefined;
		}

		const dateTime = this.timeService.getLuxonDateTime(rawValue);
		return dateTime.toJSDate();
	});

	public readonly enableFlatPickr = computed<boolean>(() => {
		if (this.isBrowserPlatform()) {
			// flatpickr is not supported on server
			return true;
		}
		return false;
	})

	constructor() {
		super();
	}

	handleDateUpdate(value?: FlatPickrOutputOptions): void {
		if (!value || !value.selectedDates.length) {
			super.updateValue(undefined);
		} else {
			const selectedDate = value.selectedDates[0];
			const selectedDateTime = this.timeService.getLuxonDateTime(selectedDate);
			const formattedDbDate = this.timeService.toISODate(selectedDateTime);
			super.updateValue(formattedDbDate);
		}
	}

	protected getHint(value?: ISODate): string | undefined {
		return undefined;
	}

	protected isValueValid(value?: ISODate): boolean {
		return true;
	}
}
